var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"grid-parent"},[(_vm.heading)?_c('h2',[_vm._v("\n        "+_vm._s(_vm.heading)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.classes},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }